(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-ambassador"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[id^="Ambassador-"]').forEach((section) => {
      const openButton = section.querySelector('[data-ambassador-open]');
      const modal = section.querySelector('[data-ambassador-modal]');
      const closeButton = section.querySelector('[data-ambassador-close]');
      const modalVideo = modal ? modal.querySelector('video') : null;

      if (!openButton || !modal) return;

      const closeModal = () => {
        if (modalVideo) modalVideo.pause();
        if (modal.open) modal.close();
      };

      openButton.addEventListener('click', () => {
        modal.showModal();
        if (modalVideo) {
          modalVideo.currentTime = 0;
          const playPromise = modalVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }
      });

      if (closeButton) closeButton.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      modal.addEventListener('close', () => {
        if (modalVideo) modalVideo.pause();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truniagen-all-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[id^="TNAllBenefits-"]');
    sections.forEach((section) => {
      const tabs = Array.from(section.querySelectorAll('[data-tn-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-tn-panel]'));
      const accordions = Array.from(section.querySelectorAll('[data-tn-accordion]'));

      const setActive = (target) => {
        tabs.forEach((item) => {
          const active = item.dataset.tnTab === target;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tnPanel === target));
        accordions.forEach((accordion) => accordion.setAttribute('aria-expanded', accordion.dataset.tnAccordion === target ? 'true' : 'false'));
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActive(tab.dataset.tnTab));
      });

      accordions.forEach((accordion) => {
        accordion.addEventListener('click', () => {
          const target = accordion.dataset.tnAccordion;
          const panel = panels.find((item) => item.dataset.tnPanel === target);
          const isOpen = panel && panel.classList.contains('is-active');

          if (isOpen) {
            panel.classList.remove('is-active');
            accordion.setAttribute('aria-expanded', 'false');
          } else {
            setActive(target);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
